import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot} from '@angular/router';
import {AbogadosService} from './abogados.service';
import {AbogadoDetail} from '../domain/abogado-detail';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';

@Injectable()
export class AbogadoDetailResolver implements Resolve<AbogadoDetail> {

    constructor(private service: AbogadosService, private router: Router) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<AbogadoDetail> {
        return this.service.get(+route.params['id'])
            .map(abogado => new AbogadoDetail(abogado))
            .catch(err => {
                this.router.navigate(['home', 'abogados']);
                return Observable.of(null)
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/fiscalia/service/abogado-detail-resolver.service.ts